<template>
    <div>
        <f-modal ref="modal">
            <div class="bg-green/80 rounded-xl text-white">
                <div class="flex flex-col py-6">
                    <div class="px-4 text-center font-medium" v-html="$t('feedback.question.joy')"></div>

                    <div class="px-4 grid mt-6 grid-cols-1 xs:grid-cols-2 gap-4">
                        <f-button @click="openFeedback()" class="rounded-lg border border-white whitespace-nowrap">
                            {{ $t('feedback.button.not.really') }}
                        </f-button>

                        <f-button @click="openRating()" class="bg-white text-green rounded-lg">
                            {{ $t('feedback.button.yes') }}
                        </f-button>
                    </div>
                </div>

                <div class="flex flex-row border-t border-white h-12">
                    <f-button @click="$refs.modal.close()" class="w-full">
                        {{ $t('feedback.button.close') }}
                    </f-button>
                </div>
            </div>
        </f-modal>

        <f-modal ref="feedbackModal">
            <div class="bg-green/80 rounded-xl text-white">
                <div class="flex flex-col py-6 gap-y-6">
                    <div class="px-8 text-center font-medium" v-html="$t('feedback.question.help.by.giving.feedback')"></div>

                    <div class="px-8 text-center">
                        <f-button
                                tag="a"
                                href="mailto:info@forexillustrated.com"
                                @click="$refs.feedbackModal.close()"
                                class="bg-white text-green rounded-lg"
                        >
                            {{ $t('feedback.button.send.a.review') }}
                        </f-button>
                    </div>
                </div>

                <div class="flex flex-row border-t border-white h-12">
                    <f-button @click="$refs.feedbackModal.close()" class="w-full">
                        {{ $t('feedback.button.close') }}
                    </f-button>
                </div>
            </div>
        </f-modal>

        <f-modal ref="ratingModal">
            <div class="bg-green/80 rounded-xl text-white">
                <div class="flex flex-col py-6 gap-y-6">
                    <div class="px-8 text-center font-medium" v-html="$t('feedback.question.rate.us')"></div>

                    <div class="px-8 text-center">
                        <f-button
                                tag="a"
                                @click="openAppStore()"
                                target="_blank"
                                class="bg-white text-green rounded-lg"
                        >
                            {{ $t('feedback.button.ok.sure') }}
                        </f-button>
                    </div>
                </div>

                <div class="flex flex-row border-t border-white h-12">
                    <f-button @click="$refs.ratingModal.close()" class="w-full">
                        {{ $t('feedback.button.close') }}
                    </f-button>
                </div>
            </div>
        </f-modal>
    </div>
</template>

<script>
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { AppLauncher } from '@capacitor/app-launcher'
import ConfigService from '@/services/ConfigService'
import StorageService from '@/services/StorageService.js'

export default {
  name: 'FeedbackModal',
  methods: {
    async open (nonInteractive = false) {
      const now = new Date().getTime()

      if (nonInteractive) {
        const lastOpened = await StorageService.get('feedback_last_opened')

        // skip if the modal was opened less than 24h ago
        if (lastOpened && now - lastOpened < 24 * 60 * 60 * 1000) {
          return
        }
      }

      const feedbackEnabled = await ConfigService.getBoolean('feedback_enabled')

      if (feedbackEnabled) {
        this.$refs.modal.open()
      } else {
        this.$refs.ratingModal.open()
      }

      // Store the last time the modal was opened
      await StorageService.set('feedback_last_opened', now)
    },
    async openFeedback () {
      await this.$refs.modal.close()
      await this.$refs.feedbackModal.open()
    },
    async openRating () {
      await this.$refs.modal.close()
      await this.$refs.ratingModal.open()
    },
    async openAppStore() {
      const url = await this.getAppStoreUrl()

      if (Capacitor.getPlatform() === 'android') {
        // Android
        await AppLauncher.canOpenUrl({ url })
        await AppLauncher.openUrl({ url })
      } else {
        // Web & iOS
        window.open(url, '_blank')
      }

      await this.$refs.ratingModal.close()
    },
    async getAppStoreUrl () {
      if (Capacitor.getPlatform() === 'android') {
        const { id } = await App.getInfo()
        return `market://details?id=${id}`
      } else if (Capacitor.getPlatform() === 'ios') {
        const appleAppId = await ConfigService.getString('apple_app_id')
        // FIXME: itms-apps://itunes.apple.com/app/id${APPLE_APP_ID}?action=write-review protocol doesn't work
        return `https://itunes.apple.com/app/id${appleAppId}?action=write-review`
      } else {
        // TODO implement based on user agent
        return 'https://play.google.com/store/apps/details?id=lv.fitstergroup.forexhero'
      }
    }
  }
}
</script>
